var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0ZM11.4536 5.4464C11.3665 5.35933 11.2503 5.30746 11.1274 5.30074C11.0044 5.29403 10.8833 5.33293 10.7872 5.41L10.7464 5.4464L6.7 9.4928L5.2536 8.0464C5.16318 7.95595 5.04154 7.90359 4.9137 7.90008C4.78586 7.89657 4.66153 7.94219 4.56629 8.02754C4.47105 8.11289 4.41213 8.2315 4.40166 8.35896C4.39119 8.48642 4.42996 8.61305 4.51 8.7128L4.5464 8.7536L6.3464 10.5536C6.4335 10.6407 6.54966 10.6925 6.67264 10.6993C6.79561 10.706 6.91674 10.6671 7.0128 10.59L7.0536 10.5536L11.4536 6.1536C11.5 6.10717 11.5369 6.05204 11.562 5.99137C11.5872 5.9307 11.6001 5.86567 11.6001 5.8C11.6001 5.73433 11.5872 5.6693 11.562 5.60863C11.5369 5.54796 11.5 5.49283 11.4536 5.4464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked_circle.4154662a8cae525261286e2e1e77851a.svg";
export { ForwardRef as ReactComponent };